import { Injectable } from '@angular/core';
import { ConfirmationModalOverlayRef } from '@core/customCDK/cdkCustomMdl/classes/confirmation-modal.ref';
import { ConfirmationComponent } from '@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';
import {
  ConfirmationModalConfig,
  ConfirmationModalService,
} from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { ToastrService } from 'ngx-toastr';
import { filter, Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  confirmationRef!: ConfirmationModalOverlayRef;
  constructor(
    private toastr: ToastrService,
    private _ConfirmationModalService: ConfirmationModalService
  ) {}

  showSuccess(message: any, title: any) {
    this.toastr.success(message, title);
  }

  showError(message: any, title: any) {
    this.toastr.error(message, title);
  }

  showInfo(message: any, title: any) {
    this.toastr.info(message, title);
  }

  showWarning(message: any, title: any) {
    this.toastr.warning(message, title);
  }

  openSubmitConfirmationModal(message?: string) {
    //console.log("modal clicked")
    let customConfig: ConfirmationModalConfig = {
      data: {
        icon: 'custom',
        title: 'Sorry!',
        msg: message,
        btnConfirm: '',
        btnClose: 'Okay',
      },
    };

    this.confirmationRef =
      this._ConfirmationModalService.open<ConfirmationComponent>(
        ConfirmationComponent,
        customConfig
      );
    this.confirmationRef.events
      .pipe(
        filter((event) => {
          //console.log(event);
          return !!event;
        })
      )
      .subscribe((events) => {
        switch (events.type) {
          case 'confirm':
            //console.log('confirmed action, proceed');

            break;
          case 'close':
            //console.log('close modal');
            this.confirmationRef?.close(customConfig);
            break;
        }
      });
  }
}
